module.exports = __webpack_public_path__ + "img/carrousel-captores-3.a6c2404c.jpg";